export default Object.freeze({
  STEPS: [
    {
      target: '#v-step-0',
      content: 'EXCELの様に編集できます',
      params: {
        enableScrolling: false,
        placement: 'bottom'
      }
    }
  ],
  STEPS2: [
    {
      target: '#v-jspreadsheet-0',
      content: 'EXCELからのコピー＆ペーストの際は<br>関連列の後ろから貼り付けてください',
      params: {
        enableScrolling: false,
        placement: 'top'
      }
    }
  ]
})
